<script>
import DataLabel from '@/js/components/common/labels/DataLabel';

export default {
    name: 'OptionalLabel',

    functional: true,

    props: {
        value: {type: null, default: null},
        none: {type: String, default: null},
    },

    render(createElement, {props, data, parent}) {
        data.props = {
            item: props.value || null,
            hideIcon: true,
            none: props.none || parent.$t('common.labels.optional.nil'),
        };

        return createElement(DataLabel, data);
    },
};
</script>
